import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Typography,
  Box,
  Button,
  Avatar,
  Grid,
  Card,
  CardContent,
  CardMedia,
  CardActionArea,
  Container,
  Paper
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import '../styles/pages/CompletarPerfil.scss';

// Avatares disponíveis (usando cores e ícones como placeholders)
const avatares = [
  {
    id: 1,
    nome: 'Avatar Azul',
    cor: '#667eea',
    descricao: 'Avatar padrão da plataforma'
  },
  {
    id: 2,
    nome: 'Avatar Verde',
    cor: '#4caf50',
    descricao: 'Primeira opção de avatar'
  },
  {
    id: 3,
    nome: 'Avatar Roxo',
    cor: '#9c27b0',
    descricao: 'Segunda opção de avatar'
  },
  {
    id: 4,
    nome: 'Avatar Laranja',
    cor: '#ff9800',
    descricao: 'Terceira opção de avatar'
  },
  {
    id: 5,
    nome: 'Avatar Vermelho',
    cor: '#f44336',
    descricao: 'Quarta opção de avatar'
  },
  {
    id: 6,
    nome: 'Avatar Rosa',
    cor: '#e91e63',
    descricao: 'Quinta opção de avatar'
  }
];

const CompletarPerfil: React.FC = () => {
  const navigate = useNavigate();
  const [avatarSelecionado, setAvatarSelecionado] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const handleAvatarSelect = (avatarId: number) => {
    setAvatarSelecionado(avatarId);
  };

  const handleContinuar = async () => {
    if (!avatarSelecionado) {
      return;
    }

    setLoading(true);
    
    // Simular um pequeno delay para mostrar o loading
    setTimeout(() => {
      setLoading(false);
      // Redirecionar para a página principal do membro
      navigate('/membro');
    }, 1000);
  };

  return (
    <div className="completar-perfil-page">
      <Container maxWidth="md">
        <Paper elevation={3} className="perfil-container">
          <Box className="perfil-header">
            <Typography variant="h4" component="h1" gutterBottom className="perfil-title">
              Completar Perfil
            </Typography>
            <Typography variant="body1" className="perfil-subtitle">
              Escolha um avatar para personalizar seu perfil na plataforma
            </Typography>
          </Box>

          <Box className="avatar-selection">
            <Typography variant="h6" gutterBottom className="selection-title">
              Selecione um Avatar
            </Typography>
            
            <Grid container spacing={3} className="avatar-grid">
              {avatares.map((avatar) => (
                <Grid item xs={12} sm={6} md={4} key={avatar.id}>
                  <Card 
                    className={`avatar-card ${avatarSelecionado === avatar.id ? 'selected' : ''}`}
                    onClick={() => handleAvatarSelect(avatar.id)}
                  >
                    <CardActionArea>
                      <Box 
                        className="avatar-placeholder"
                        style={{ backgroundColor: avatar.cor }}
                      >
                        <Typography variant="h4" className="avatar-initial">
                          {avatar.nome.charAt(0)}
                        </Typography>
                      </Box>
                      <CardContent className="avatar-content">
                        <Typography variant="subtitle2" component="div" className="avatar-name">
                          {avatar.nome}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" className="avatar-description">
                          {avatar.descricao}
                        </Typography>
                        {avatarSelecionado === avatar.id && (
                          <CheckCircle className="selected-icon" />
                        )}
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>

          <Box className="perfil-actions">
            <Button
              variant="contained"
              color="primary"
              size="large"
              fullWidth
              disabled={!avatarSelecionado || loading}
              onClick={handleContinuar}
              className="btn-continuar"
            >
              {loading ? 'Carregando...' : 'Continuar'}
            </Button>
            
            <Typography variant="body2" className="skip-text">
              Você pode alterar seu avatar a qualquer momento nas configurações do perfil
            </Typography>
          </Box>
        </Paper>
      </Container>
    </div>
  );
};

export default CompletarPerfil;
